import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/apiClient";
import { BrandMark } from "@/components/BrandMark";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";
import { toast } from "sonner";
import { Loader2, KeyRound } from "lucide-react";

export default function MemberSetPassword() {
  const token = new URLSearchParams(window.location.search).get("token") || "";
  const navigate = useNavigate();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 8) return toast.error("Password must be at least 8 characters");
    if (pw !== pw2) return toast.error("Passwords don't match");
    setLoading(true);
    try {
      const { data } = await api.post("/membership/set-password", { token, password: pw });
      toast.success("Password set - you can now sign in");
      navigate(`/members?email=${encodeURIComponent(data.email)}`);
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); setLoading(false); }
  };
  return (
    <div className="min-h-screen bg-background">
      <header className="h-16 border-b border-border"><div className="max-w-3xl mx-auto h-full flex items-center px-4 sm:px-6"><BrandMark /></div></header>
      <main className="max-w-md mx-auto px-4 py-16">
        <Card className="p-8">
          <h1 className="font-heading text-2xl font-bold flex items-center gap-2"><KeyRound className="h-6 w-6 text-primary" />Set your member password</h1>
          {!token ? <p className="text-sm text-muted-foreground mt-4">This link is missing its token. Please use the link from your email.</p> : (
            <form onSubmit={submit} className="space-y-4 mt-6">
              <div><Label>New password</Label><Input type="password" value={pw} onChange={(e) => setPw(e.target.value)} className="mt-1.5" data-testid="member-new-password-input" /></div>
              <div><Label>Confirm password</Label><Input type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} className="mt-1.5" data-testid="member-confirm-password-input" /></div>
              <Button type="submit" className="w-full" disabled={loading} data-testid="member-set-password-button">{loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Set password"}</Button>
            </form>
          )}
          <Link to="/members" className="block text-sm text-primary hover:underline mt-4" data-testid="member-back-signin">Back to sign in</Link>
        </Card>
      </main>
    </div>
  );
}
